import { FeatureFlagKey } from "@redotech/feature-flags-model/keys";
import { useRequiredContext } from "@redotech/react-util/context";
import { useLoad } from "@redotech/react-util/load";
import ContextualIcon from "@redotech/redo-icons/contextual.svg";
import { RedoMarketingRpcClientContext } from "@redotech/redo-merchant-app-common/marketing-rpc-client-provider";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { RedoSecondaryNavItem } from "@redotech/redo-web/arbiter-components/navigation/secondary/redo-secondary-nav-item";
import { memo } from "react";
import { matchPath, useLocation } from "react-router-dom";

export const ContextualItems = memo(function ContextualItems() {
  const routes = useRequiredContext(MerchantRoutesContext);
  const marketingRpcClient = useRequiredContext(RedoMarketingRpcClientContext);
  const location = useLocation();

  const flagLoad = useLoad(
    (signal) =>
      marketingRpcClient.getBooleanFeatureFlag(
        { key: FeatureFlagKey.CONTEXTUAL_ONBOARDING },
        { signal },
      ),
    [marketingRpcClient],
  );

  const isEnabled = flagLoad.value?.enabled ?? false;

  // TODO: Replace with RPC query for onboarding status
  const onboardingCompleted = false;

  const contextualRoot = routes.contextualHref;
  const anyChildSelected = !!matchPath(
    `${contextualRoot}/*`,
    location.pathname,
  );

  return (
    <>
      {/* Flat nav item when onboarding is not complete */}
      <RedoSecondaryNavItem
        action={{ type: "link", href: routes.contextualHref }}
        anyChildSelected={anyChildSelected}
        FilledIcon={ContextualIcon}
        friendlyName="Contextual"
        hidden={!isEnabled || onboardingCompleted}
        id="contextual-setup"
        UnfilledIcon={ContextualIcon}
      />
      {/* Dropdown with children when onboarding is complete */}
      <RedoSecondaryNavItem
        action={{
          type: "link",
          href: routes.getContextualSubRoute("dashboard"),
        }}
        anyChildSelected={anyChildSelected}
        FilledIcon={ContextualIcon}
        friendlyName="Contextual"
        hidden={!isEnabled || !onboardingCompleted}
        id="contextual"
        UnfilledIcon={ContextualIcon}
      >
        <RedoSecondaryNavItem
          action={{
            type: "link",
            href: routes.getContextualSubRoute("dashboard"),
          }}
          friendlyName="Dashboard"
          id="contextual-dashboard"
        />
      </RedoSecondaryNavItem>
    </>
  );
});
